<div class="w-full readonly-banner flex justify-around mb-1" *ngIf="disabled">You are in a read only view.  Contact your admin to make changes to intent settings.</div>
<div class="flex flex-wrap -mx-2" *ngIf="!isLoading; else loader">
    <div class="flex-none w-full px-2">
        <mat-list class="w-full intent-plans-list">
            <mat-list-item *ngFor="let plan of plans; let ids = index;">
                <div class="flex w-full">
                <ng-container *ngIf="ids === 0">
                    <h5 class="whitespace-nowrap param-name mb-0">{{plan.label}}: </h5>
                    <h5 class="grow mb-0">{{plan.value}}</h5>
                </ng-container>
                <ng-container *ngIf="ids !== 0">
                    <span class="whitespace-nowrap param-name font-bold">{{plan.label}}: </span>
                    <span class="grow">{{plan.value | number}}</span>
                </ng-container>
                </div>
            </mat-list-item>
        </mat-list>
    </div>

    <div class="flex-none w-full my-2 px-2" *ngIf="!disabled">
        Select up to {{planPropertyValues?.maxTopics | number}} topics that can be used by your team.
    </div>
</div>

<div class="flex flex-wrap -mx-2">
    <div class="flex-none w-1/2 px-2">
        <h4>Available topics ({{topics | intentDataTopicCount | number}})</h4>
        <div class="flex justify-start py-1">
            <p class="mb-1 mr-2">Filter by:</p>
            <mat-radio-group [(ngModel)]="filterIntentType">
                <mat-radio-button class="mr-2" value="categories">Categories</mat-radio-button>
                <mat-radio-button value="topics">Topics</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <div class="flex-none w-1/2 px-2">
        <h4>
            Your topics ({{existingTopics?.length | number}})
            <span class="a float-right" (click)="removeAll()" [ngClass]="{disable: disabled}">Remove All</span>
        </h4>
    </div>
</div>

<div class="flex flex-wrap -mx-2 intent-section">
    <div class="flex-none w-1/2 px-2">
        <mat-form-field appearance="outline" class="mb-2 w-full no-padding">
            <mat-label>Filter by {{filterIntentType === 'categories' ? 'category' : 'topic'}}</mat-label>
            <input matInput type="text" placeholder="Filter by {{filterIntentType === 'categories' ? 'category' : 'topic'}}" [(ngModel)]="searchAvailableTopic">
            <fa-icon class="mat-primary si-icon" matSuffix [icon]="['fal', 'magnifying-glass']"></fa-icon>
        </mat-form-field>

        <div class="border rounded overflow-hidden bg-white">
            <mat-list class="list-topics">
                <cdk-virtual-scroll-viewport itemSize="48" *ngIf="topics?.length; else noAvailableTopicsTpl">
                    <ng-container *cdkVirtualFor="let topic of topics | topicsFilter: searchAvailableTopic : filterIntentType">
                        <!-- Category labels: non-interactive (no click, no pointer) -->
                        <mat-list-item
                            *ngIf="topic.category; else topicRowTpl"
                            class="intent-topic-item category-name bg-tab font-bold"
                            [ngClass]="{ disable: disabled }"
                        >
                            <span class="block">{{topic.category}}</span>
                        </mat-list-item>

                        <!-- Topics: clickable -->
                        <ng-template #topicRowTpl>
                            <button
                                mat-list-item
                                type="button"
                                class="intent-topic-item cursor-pointer"
                                [disabled]="disabled"
                                [ngClass]="{ disable: disabled }"
                                (click)="addTopic(topic)"
                            >
                                <div class="list-group-item__wrapper flex justify-between items-center">
                                    <span class="truncate list-group-item__text">{{topic.topic_name}}</span>
                                    <fa-icon *ngIf="!existingTopicsAcc?.[topic.topic_id]; else selectedTpl" class="text-dark py-0 ml-2" [icon]="['fas', 'plus']"></fa-icon>

                                    <ng-template #selectedTpl>
                                        <fa-icon class="text-success py-0 ml-2" [icon]="['fas', 'check']"></fa-icon>
                                    </ng-template>
                                </div>
                            </button>
                        </ng-template>
                    </ng-container>
                </cdk-virtual-scroll-viewport>
                <ng-template #noAvailableTopicsTpl>
                    <mat-list-item class="flex justify-between items-center break-words py-2">
                        No Topics Found
                    </mat-list-item>
                </ng-template>
            </mat-list>
        </div>
    </div>

    <div class="flex-none w-1/2 px-2">
        <mat-form-field appearance="outline" class="mb-2 w-full no-padding">
            <mat-label>Filter by topic</mat-label>
            <input matInput type="text" placeholder="Filter by topic" [(ngModel)]="searchYourTopic">
            <fa-icon class="mat-primary si-icon" matSuffix [icon]="['fal', 'magnifying-glass']"></fa-icon>
        </mat-form-field>
        <div class="border rounded overflow-hidden bg-white">
            <mat-list class="list-topics">
                <mat-list-item *ngFor="let topic of existingTopics | existingTopicsFilter: searchYourTopic | orderBy : 'topic_name'"
                    class="break-words py-2"
                    [disabled]="disabled"
                    [ngClass]="{disable: disabled}">
                    <div class="flex justify-between items-center w-full">
                    <span class="truncate">{{topic.topic_name}}</span>
                    <button
                        matIconButton
                        class="mat-error"
                        type="button"
                        title="Delete"
                            [disabled]="disabled"
                        (click)="deleteTopic(topic)"
                    >
                        <fa-icon class="si-icon" [icon]="['fal', 'trash-can']"></fa-icon>
                    </button>
                    </div>
                </mat-list-item>
                <mat-list-item *ngIf="!existingTopics?.length" class="flex justify-between items-center break-words py-2">
                    No Topics Found
                </mat-list-item>
            </mat-list>
        </div>
    </div>
</div>

<ng-template #loader class="flex flex-wrap -mx-2">
    <div class="flex-none w-full my-12 px-2">
        <article class="flex justify-center">
            <mat-spinner></mat-spinner>
        </article>
    </div>
</ng-template>
